import React, { JSX } from 'react';
import { PostsPerPageType } from '../store';
import Style from './Pagination.module.scss';

type Props = {
  postsPerPage: PostsPerPageType;
  totalPosts: number;
  currentPage: number;
  paginate: (pageNumber: number) => void;
};

const Pagination: React.FC<Props> = ({ postsPerPage, totalPosts, currentPage, paginate }): JSX.Element => {
  const totalPageNum = Math.ceil(totalPosts / postsPerPage);

  return (
    <div className={Style.pagination}>
      <button className={Style.next} onClick={() => paginate(currentPage - 1)} disabled={currentPage <= 1}>
        新しい情報へ
      </button>
      <span className={Style.number}>
        {currentPage} / {totalPageNum}
      </span>
      <button className={Style.prev} onClick={() => paginate(currentPage + 1)} disabled={currentPage >= totalPageNum}>
        古い情報へ
      </button>
    </div>
  );
};

export default Pagination;
